var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 1.25H9V0.5C9 0.25 8.75 0 8.5 0H7.5C7.21875 0 7 0.25 7 0.5V1.25H0.5C0.21875 1.25 0 1.5 0 1.75V2.25C0 2.53125 0.21875 2.75 0.5 2.75H7V3.5C7 3.78125 7.21875 4 7.5 4H8.5C8.75 4 9 3.78125 9 3.5V2.75H15.5C15.75 2.75 16 2.53125 16 2.25V1.75C16 1.5 15.75 1.25 15.5 1.25ZM15.5 11.25H5V10.5C5 10.25 4.75 10 4.5 10H3.5C3.21875 10 3 10.25 3 10.5V11.25H0.5C0.21875 11.25 0 11.5 0 11.75V12.25C0 12.5312 0.21875 12.75 0.5 12.75H3V13.5C3 13.7812 3.21875 14 3.5 14H4.5C4.75 14 5 13.7812 5 13.5V12.75H15.5C15.75 12.75 16 12.5312 16 12.25V11.75C16 11.5 15.75 11.25 15.5 11.25ZM15.5 6.25H13V5.5C13 5.25 12.75 5 12.5 5H11.5C11.2188 5 11 5.25 11 5.5V6.25H0.5C0.21875 6.25 0 6.5 0 6.75V7.25C0 7.53125 0.21875 7.75 0.5 7.75H11V8.5C11 8.78125 11.2188 9 11.5 9H12.5C12.75 9 13 8.78125 13 8.5V7.75H15.5C15.75 7.75 16 7.53125 16 7.25V6.75C16 6.5 15.75 6.25 15.5 6.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumns);
export default __webpack_public_path__ + "static/media/columns.d2cf9e9d.svg";
export { ForwardRef as ReactComponent };